import { createSlice } from "@reduxjs/toolkit";

export type HeaderState = {
  leftHeaderButton: React.FunctionComponent | null;
  rightHeaderButton: React.FunctionComponent | null;
};

const initialState: HeaderState = {
  leftHeaderButton: null,
  rightHeaderButton: null
};

/** Header Slice */
const { reducer, actions } = createSlice({
  name: "headerSlice",
  initialState,
  reducers: {
    setLeftHeaderButton: (state, { payload }) => {
      state.leftHeaderButton = payload;
    },
    setRightHeaderButton: (state, { payload }) => {
      state.rightHeaderButton = payload;
    }
  }
});

export const { setLeftHeaderButton, setRightHeaderButton } = actions;

export default reducer;
